export const CREATE_PLACE = gql`
  mutation CreatePlace($input: CreatePlaceInput!) {
    res: createPlace(input: $input) {
      id
      addressCountry
      streetAddress1
      streetAddress2
      googlePlaceId
      city
      postalCode
      faxNumber
      state
      isActive
      disabled
      phone
      primaryContact {
        id
        name
      }
      description
      addressRoles
    }
  }
`;

export const UPDATE_PLACE = gql`
  mutation UpdatePlace($id: Int!, $input: UpdatePlaceInput!) {
    updatePlace(id: $id, input: $input) {
      id
      disabled
      streetAddress1
      city
      state
      postalCode
      addressCountry
      description
    }
  }
`;
